import { motion } from "framer-motion";

export default function Marquee({
    items,
    speed = 40,
    className = "",
    itemClassName = "",
}) {
    const doubled = [...items, ...items];
    return (
        <div className={`overflow-hidden ${className}`}>
            <motion.div
                className="flex whitespace-nowrap will-change-transform"
                animate={{ x: ["0%", "-50%"] }}
                transition={{
                    duration: speed,
                    ease: "linear",
                    repeat: Infinity,
                }}
            >
                {doubled.map((it, i) => (
                    <span
                        key={i}
                        className={`inline-flex items-center px-8 ${itemClassName}`}
                    >
                        {it}
                    </span>
                ))}
            </motion.div>
        </div>
    );
}
